import {AbstractDTO} from "frontend-core";
import {SegmentationTarget} from "@/modules/Segmentation/models/SegmentationTarget";
import {SegmentRuleDto} from "@/modules/Segmentation/models/SegmentRuleDto";
import {AntiSegmentRuleDto} from "@/modules/Segmentation/models/AntiSegmentRuleDto";
import {ISegmentDto} from "@/modules/Segmentation/models/SegmentRule";
import {IAntiSegmentDto} from "@/modules/Segmentation/models/AntiSegmentRule";

export class SegmentationTargetDTO extends AbstractDTO {
    constructor(protected readonly model: SegmentationTarget) {
        super(model);

        this.rules = {
            rules: () => {
                this.model.segments.forEach((i) => {
                    new SegmentRuleDto(i).validate();
                });

                this.model.antiSegments.forEach((i) => {
                    new AntiSegmentRuleDto(i).validate();
                });

                return this.model.segments.every(i => i.isValid) && this.model.antiSegments.every(i => i.isValid)
                    || ["Проверьте правила"]
            }
        };
    }

    serialize(): ISegmentationTargetDTOJson {
        return {
            parent: this.model.parentId,
            antiSegments: this.model.antiSegments.map(i => new AntiSegmentRuleDto(i).serialize()),
            segments: this.model.segments.map(i => new SegmentRuleDto(i).serialize()),
        };
    }
}

export interface ISegmentationTargetDTOJson {
    "segments": ISegmentDto[],
    "antiSegments": IAntiSegmentDto[],
    "parent": string | null
}
